import { Injectable } from '@angular/core';
import { OverlayContainer } from 'ngx-toastr';

/**
 * Custom OverlayContainer that uses the Popover API so toastr toasts
 * render in the browser's top layer — above Angular CDK dialogs which
 * also use the top layer in CDK v17+.
 *
 * The container is re-promoted to the top of the top layer every time
 * getContainerElement() is called (i.e. when a new toast is shown),
 * ensuring it always appears above any open dialogs.
 */
@Injectable({ providedIn: 'root' })
export class ToastrOverlayContainer extends OverlayContainer {
    protected override _createContainer(): void {
        const container = this._document.createElement('div');
        container.classList.add('overlay-container');
        container.setAttribute('aria-live', 'polite');

        if ('popover' in container) {
            container.setAttribute('popover', 'manual');
            this._document.body.appendChild(container);
            (container as any).showPopover();
        } else {
            this._document.body.appendChild(container);
        }

        this._containerElement = container;
    }

    //not sure if needed
    /*override getContainerElement(): HTMLElement {
        if (!this._containerElement) {
            this._createContainer();
        }

        const el = this._containerElement as any;
        if (el && 'showPopover' in el) {
            try {
                el.hidePopover();
            } catch { 
             // already hidden *
            }
            el.showPopover();
        }

        return this._containerElement;
    }*/
}
